var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.imageList),function(item,index){return _c('div',{key:'sceneMaterialImage'+index},[_c('scene-material-image',{attrs:{"imageInfo":item},on:{"clickMarker":_vm.clickMarker}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }